module.exports = __webpack_public_path__ + "static/media/wizualizacja-58.fd684f98.png";